/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { SystemInfo } from "libs/sysque/toolbelt/data-access/src/lib/domain/system-info";
import { SystemOptionsReturnCodes } from "../sysque-system-category-options/sysque-system-category-options.component";
import { CategoryOptionsReturnCodes } from "./category-options-return-codes";
import { TabDescription } from "libs/sysque/toolbelt/data-access/src/lib/domain/tab-description";

export class SysQueSystemsOperationsResult {
    returnCode: SystemOptionsReturnCodes;
    systems: SystemInfo[];
}

export class SysQueCategoryOperationsResult {
    returnCode: CategoryOptionsReturnCodes;
    categories: TabDescription[];
}